import { FallbackRender } from "@sentry/react";
import { CrashPage } from "components/errors/CrashPage";

/**
 * The outermost boundary's page, for a crash above or outside the router.
 *
 * No way back is offered here: this renders outside `RouterProvider`, where a
 * `Link` has no router to resolve against, so a reload is the one action it
 * can take.
 */
export const ErrorFallback: FallbackRender = ({ error }) => (
  <CrashPage error={error} />
);
